import i18n from '../i18n/i18n';

export const END_OF_DAY = new Date(0, 0, 0, 23, 59, 59, 999);

const MS_PER_DAY = 1000 * 60 * 60 * 24;
const DAYS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];

/**
 * Převod Obejct:Date do řetězce včetně času
 * @param date {Date} datum a čas
 * @return {String} datum
 */
export const dateToDateTimeString = formatDateTime; // Alias pro zpětnou kompatibilitu

/**
 * Převod datumu do řetězce - v budoucnu při více locale nahradit metodou pracující s locale.
 * @param date {Date} datum
 * @return {String} datum
 */
export const dateToDateString = formatDate; // Alias pro zpětnou kompatibilitu

/**
 * Převod Obejct:Date do řetězce obsahující čas
 * @param date {Date} datum a čas
 * @return {String} čas
 */
export const dateToTimeString = formatTime; // Alias pro zpětnou kompatibilitu

/**
 * Převede datum a čas na naformátovaný řetězec.
 *
 * @param {Date} [date] - datum
 * @param {object} [options] - dodatečné parametry
 * @param {boolean} [options.useDayNames=false] - pro nejbližších 7 dní vrátí jednu z konstant 'dnes', 'po', 'út', ..., 'ne'
 * @param {boolean} [options.includeYear=true] - vrátí rok jako součást výsledného řetězce
 * @param {boolean} [options.includeSeconds=false] - vrátí sekundy jako součást výsledného řetězce
 * @return {String} naformátované datum nebo null pro null vstup
 */
export function formatDateTime(dateTime, options) {
    if (!dateTime) {
        return null;
    }
    return formatDate(dateTime, options) + ' ' + formatTime(dateTime, options);
}

/**
 * Převede datum na naformátovaný řetězec.
 *
 * @param {Date} [date] - datum
 * @param {object} [options] - dodatečné parametry
 * @param {boolean} [options.useDayNames=false] - pro nejbližších 7 dní vrátí jednu z konstant 'dnes', 'po', 'út', ..., 'ne'
 * @param {boolean} [options.includeYear=true] - vrátí rok jako součást výsledného řetězce
 * @param {boolean} [options.shortFormat=true] - vrací zkrácený formát čísel (např. 5. 3. 2017)
 * @return {String} naformátované datum nebo null pro null vstup
 */
export function formatDate(date, options = {}) {
    if (!date) {
        return null;
    }

    const {useDayNames = false} = options;
    if (useDayNames) {
        const dayDiff = dateDiffInDays(new Date(), date);
        if (dayDiff === 0) {
            return i18n('global.days.today');
        }
        if (dayDiff > 0 && dayDiff < 7) {
            return i18n('global.days.short.' + DAYS[date.getDay()]);
        }
    }

    const {shortFormat = true} = options;
    let result;
    if (shortFormat) {
        result = date.getDate() + ". " + (date.getMonth() + 1) + ".";
    } else {
        result = _dtpad(date.getDate()) + "." + _dtpad(date.getMonth() + 1) + ".";
    }

    const {includeYear = true} = options;
    if (includeYear) {
        if (shortFormat) {
            result += ' ';
        }
        result += date.getFullYear();
    }

    return result;
}

/**
 * Převede čas na naformátovaný řetězec.
 *
 * @param {Date} [time] - čas
 * @param {object} [options] - dodatečné parametry
 * @param {boolean} [options.includeSeconds=false] - vrátí sekundy jako součást výsledného řetězce
 * @return {String} naformátovaný čas nebo null pro null vstup
 */
export function formatTime(time, options = {}) {
    if (!time) {
        return null;
    }

    let result = _dtpad(time.getHours()) + ":" + _dtpad(time.getMinutes());

    const {includeSeconds = false} = options;
    if (includeSeconds) {
        result += ":" + _dtpad(time.getSeconds());
    }

    return result;
}

function dateDiffInDays(a, b) {
  var utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
  var utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
  return Math.floor((utc2 - utc1) / MS_PER_DAY);
}

function _dtpad(number) {
    var r = String(number);
    if ( r.length === 1 ) {
        r = '0' + r;
    }
    return r;
}

/**
 * Převede datum na lokální datum v UTC.
 * @param date
 * @return {*}
 */
export function dateToLocalUTC(date) {
    if (!date) {
        return date;
    }

    return date.getFullYear()
        + '-' + _dtpad( date.getMonth() + 1 )
        + '-' + _dtpad( date.getDate() )
        + 'T' + "00"
        + ':' + "00"
        + ':' + "00"
        + '.' + "000";
}

/**
 * Převede datum a čas na lokální datum a čas v UTC.
 * @param date
 * @return {*}
 */
export function dateTimeToLocalUTC(date) {
    if (!date) {
        return date;
    }

    return date.getFullYear()
        + '-' + _dtpad( date.getMonth() + 1)
        + '-' + _dtpad( date.getDate())
        + 'T' + _dtpad( date.getHours())
        + ':' + _dtpad( date.getMinutes())
        + ':' + _dtpad( date.getSeconds())
        + '.' + _dtpad( date.getMilliseconds());
}

/**
 * Převede čas na lokální čas v UTC.
 * @param date
 * @return {*}
 */
export function timeToLocalUTC(date) {
    if (!date) {
        return date;
    }

    return _dtpad( date.getHours())
        + ':' + _dtpad( date.getMinutes())
        + ':' + _dtpad( date.getSeconds())
        + '.' + _dtpad( date.getMilliseconds());
}

// NECHAT - pro testování !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// var x = new Date();
// console.log("@@@", x)
//
// console.log("@@@ DATE")
// var l = dateToLocalUTC(x);
// console.log("dateToLocalUTC", l);
// console.log("localUTCToDate", localUTCToDate(l));
// console.log("dateToLocalUTC", dateToLocalUTC(localUTCToDate(l)));
//
// console.log("@@@ DATE TIME")
// var m = dateTimeToLocalUTC(x);
// console.log("dateTimeToLocalUTC", m);
// console.log("localUTCToDateTime", localUTCToDateTime(m));
// console.log("dateTimeToLocalUTC", dateTimeToLocalUTC(localUTCToDateTime(m)));

/**
 * Převede utc zápis braný jako local date do Date instance javascriptu BEZ času.
 * @param str
 */
export function localUTCToDate(str) {
    return localUTCToDateTime(str);
}

/**
 * Převede utc zápis braný jako local date time do Date instance javascriptu VČETNĚ času.
 * @param str
 */
export function localUTCToDateTime(str) {
    if (!str) {
        return null;
    }
    if (str instanceof Date) {
        return str;
    }

    var dt = str.split(/[: T-]/).map(parseFloat);
    const seconds = dt[5] ? Math.floor(dt[5]) : 0;
    const milliseconds = dt[5] ? ((dt[5] - seconds) * 1000) : 0;
    var result = new Date(dt[0], dt[1] - 1, dt[2], dt[3] || 0, dt[4] || 0, seconds, milliseconds)
    return result;
}

/**
 * Převede utc zápis braný jako local time do Date instance javascriptu.
 * @param str
 */
export function localUTCToTime(str) {
    if (!str) {
        return null;
    }
    if (str instanceof Date) {
        return str;
    }
    if (str.indexOf('T') >= 0 || str.indexOf('-') >= 0) {
        // Vstup: datum nebo datum+cas
        const res = localUTCToDateTime(str);
        if (res instanceof Date) {
            res.setYear(0);
            res.setMonth(0);
            res.setDate(1);
        }
        return res;
    }
    if (str.indexOf(':') >= 0) {
        // Vstup: cas (bez data)
        var dt = str.split(/[:-]/).map(parseFloat);
        const seconds = dt[2] ? Math.floor(dt[2]) : 0;
        const milliseconds = dt[2] ? ((dt[2] - seconds) * 1000) : 0;
        var result = new Date(0, 0, 1, dt[0], dt[1], seconds, milliseconds)
        return result;
    }
    return null;
}

/**
 * Zkombinuje datum a čas do jedné hodnoty.
 * @param {Date} [date] - datum
 * @param {Date} [time] - čas
 * @returns {Date} - datum a čas
 */
export function combineDateTime(date: Date, time: Date): Date {
    if (!date || !time) {
        return date || time || null;
    }
    return new Date(
        date.getFullYear(), date.getMonth(), date.getDate(),
        time.getHours(), time.getMinutes(), time.getSeconds(), time.getMilliseconds()
    );
}

/**
 * Odstraní datum z datumu a času.
 * @param {Date} [dateTime] - datum a čas
 * @returns {Date} čas
 */
export function removeDate(dateTime: Date): Date {
    if (!dateTime) {
        return null;
    }
    return new Date(
        0, 0, 1,
        dateTime.getHours(), dateTime.getMinutes(), dateTime.getSeconds(), dateTime.getMilliseconds()
    );
}

/**
 * Odstraní čas z datumu a času.
 * @param {Date} [dateTime] - datum a čas
 * @returns {Date} datum
 */
export function removeTime(dateTime: Date): Date {
    if (!dateTime) {
        return null;
    }
    return new Date(
        dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate(),
        0, 0, 0, 0
    );
}

/**
 * Normalizace čísla - pouze povolené celé číslo
 * @param number string
 **/
export function normalizeInt(number) {
    let pole = ('' + number);
    let output = '';
    for (let i = 0, len = pole.length; i < len; i++) {
        if ((i === 0 && pole[i] === '-') || pole[i] === "0" || parseInt(pole[i])) {
            output += pole[i];
        }
    }
    return output;
}
/**
 * Normalizace telefonního čísla - pouze povolené celé číslo a +
 * @param number string
 **/
export function normalizePhone(number) {
    if (!number) {
        return number
    }
    let pole = ('' + number);
    let output = '';
    for (let i = 0, len = pole.length; i < len; i++) {
        if ((i === 0 && pole[i] === '+') || pole[i] === "0" || parseInt(pole[i])) {
            output += pole[i];
        }
    }
    return output;
}


/**
 * Normalizace textu na delku výchozí 255 znaků
 * @param text String
 * @param allowedLength int
 **/
export function normalizeString(text, allowedLength = 255) {
    if (text.length > allowedLength) {
        text = text.substr(0, allowedLength);
    }
    return text;
}

/**
 * Provede normalizaci hodnoty tak, aby byla čitelná pro uživatele, tedy naformátuje v jeho locales.
 * @param value hodnota
 * @return {*} hodnota pro uživatele
 */
// TODO [stanekpa] - vyřešit locales!!!
export function normalizeDoubleForUser(value) {
    if (value) {
        if (typeof value === "string") {
            return value.replace(/\./g, ',');
        } else {
            return "" + value;
        }
    } else {
        return value;
    }
}

/**
 * Normalizace čísla - lze pouze číslice a nahrazení ',' za '.' kdy náhodou - (přes string rychlejší než ukládat do pole)
 * @param number decimal(18,6)
 **/
export function normalizeDouble(number) {
    var pole = '' + number;
    var output = '';
    var existComa = false;
    for (var i = 0, len = pole.length; i < len; i++) {
        if ((i === 0 && pole[i] === '-') || parseInt(pole[i]) || pole[i] === '0' || ((pole[i] == ',' || pole[i] == '.') && !existComa && (existComa = true))) {
            output += pole[i] == ',' ? '.' : pole[i];
        }
    }
    return output;
}

/**
 * High-order funkce, sloužící pro obalení handleru komponent.
 * Výsledná funkce zajistí vyvolání preventDefault() a stopPropagation() nad vstupním event.
 *
 * Tzn. namísto:
 *
 * <button onClick={e => { this.handleEvent(e); e.preventDefault(); e.stopPropagation(); }>Test</button>
 *
 * píšeme
 *
 * <button onClick={sinkEvent(this.handleEvent)}>Test</button>
 *
 * @param callback
 * @returns výsledná callback
 */
export function sinkEvent(callback) {
    return event => {
        if (callback) {
            callback(event);
        }
        event.preventDefault();
        event.stopPropagation();
    }
}
